import type { PTConfig } from './types';

declare const __SDK_API_HOST__: string;
declare const __SDK_VERSION__: string;

/** API endpoint — injected at build time via tsup define */
export const ENDPOINT: string = (typeof __SDK_API_HOST__ === 'string' ? __SDK_API_HOST__ : '').replace(/\/+$/, '');

/** SDK build version — injected at build time via tsup define */
export const VERSION: string = typeof __SDK_VERSION__ === 'string' && __SDK_VERSION__ ? __SDK_VERSION__ : 'dev';

/** Page config — injected at publish time via <script>window.__PT_CONFIG__=...</script> */
export function getConfig(): PTConfig | null {
  const cfg = window.__PT_CONFIG__;
  if (!cfg || !cfg.pageId) return null;

  // Preview can be flagged either by config (backend-controlled) or by URL param
  // (for ad-hoc preview without re-publishing).
  let preview = !!cfg.preview;
  if (!preview) {
    try {
      preview = location.search.indexOf('ptpreview=1') !== -1;
    } catch {
      /* sandboxed */
    }
  }

  return { ...cfg, preview };
}
